// Lib
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import { getCurrentlyEditingId } from '../../../../../element/selection/currentlyEditingSelector';
import { isIndentTaskToolDisabledSelector } from './selectors/taskListToolSelector';

// Actions
import { indentTask } from '../../../../../element/taskList/taskListActions';

// Hooks
import { useActiveTiptapEditorCallback } from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const IndentTaskTool = (props: ToolbarToolProps): ReactElement => {
    const currentlyEditingId = useSelector(getCurrentlyEditingId);
    const dispatch = useDispatch();

    const isIndentToolDisabled = useSelector(isIndentTaskToolDisabledSelector);

    const handleClick = useActiveTiptapEditorCallback((activeEditor, event: PointerEvent) => {
        if (!activeEditor) return;

        const textContent = activeEditor.getJSON();

        return dispatch(
            indentTask({
                elementId: currentlyEditingId,
                textContent,
            }),
        );
    });

    return (
        <RichTextTool
            onClick={handleClick}
            iconName={props.iconName || 'toolbar-indent'}
            disabled={isIndentToolDisabled}
            {...props}
        />
    );
};

export default IndentTaskTool;
